import { Box, Typography } from '@mui/material';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults_philosophies as ProviderPhilosophies } from '@/__generated__/getSearchResults';
import shufflePhilosophies from '@/utils/shufflePhilosophies';

export interface PhilosophiesProps {
  philosophies: ProviderPhilosophies;
}

const Philosophies = ({ philosophies }: PhilosophiesProps) => {
  const philosophyList = shufflePhilosophies(philosophies);

  const philosophy =
    philosophyList.length >= 6 ? `${philosophyList.join(', ')} & more` : philosophyList.join(', ');

  if (!philosophy) {
    return null;
  }

  return (
    <Box alignItems="center" mt={1.5}>
      <Typography component="span" variant="body2" fontWeight="700">
        Philosophy:{' '}
      </Typography>
      <Typography component="span" variant="body2" fontStyle="italic">
        {philosophy}
      </Typography>
    </Box>
  );
};

export default Philosophies;
